import { Modal, Table, Button } from 'react-bootstrap';
import {ConsumerBonusCode} from "@interfaces/consumer/bonusCodes";
import {FC} from "react";

interface ConsumerCreatedBonusCodesListModalProps {
    codes: ConsumerBonusCode[];
    isOpened: boolean;
    toggle(): void;
}

const CreatedBonusCodesListModal: FC<ConsumerCreatedBonusCodesListModalProps> = ({ codes, isOpened, toggle }) => {
    return (
        <Modal
            show={isOpened}
            onHide={toggle}
            size="lg"
            centered>
            <Modal.Header closeButton>
                Созданные бонусные коды
            </Modal.Header>
            <Modal.Body>
                <Table striped>
                    <thead>
                        <tr>
                            <th>
                                Код
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            codes.length === 0 ? <tr><td align='center'>Список пуст</td></tr> :
                                codes.map(code => (
                                    <tr key={code.id}>
                                        <td align='center'>{code.code.toUpperCase()}</td>
                                    </tr>
                                ))
                        }
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button color="secondary" type="button" onClick={toggle}>
                    Закрыть
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default CreatedBonusCodesListModal;